// ABOUTME: Names shared across the feed module: the pro-core path, the React Query key, the tab the Jobs page reads and
// ABOUTME: the code the "feed is off for this talent" 404 travels under.
export const FEED_API_URL = 'talent/feed';

export const USE_FEED_QUERY_KEY = 'feed';

/** The Jobs page is the working-student tab; the only one until the feed serves more. */
export const JOBS_FEED_TAB = 'WORKING_STUDENT';

/** A 404 from pro-core: PRO_LISTING_FEED is off for this talent, or the route is not deployed yet. */
export const FEED_UNAVAILABLE_ERROR_CODE = 'error.feed.unavailable';
